// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1REvj","label":"styles_label__1DQN3"};